import { render } from "./Dunning.vue?vue&type=template&id=577cb9fa&scoped=true"
import script from "./Dunning.vue?vue&type=script&lang=js"
export * from "./Dunning.vue?vue&type=script&lang=js"

import "./Dunning.vue?vue&type=style&index=0&id=577cb9fa&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577cb9fa"]])

export default __exports__